<template>
  <div class="gov-video-list">
    <div class="container">
      <div
        class="flex"
        style="align-items: center;margin-bottom: 25px;padding-top: 25px;"
      >
        <span style="font-size: 14px;">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item style="cursor: pointer;" :to="{ name: 'govInfo' }"
            >政务信息</el-breadcrumb-item
          >
          <el-breadcrumb-item style="color: #009999"
            >视频列表</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="container">
        <div class="gov-video">
          <div class="top-title">
            <div class="live-title">政务视频</div>
            <div class="top-btn">
              <div
                class="btn-com"
                :class="
                  params.programUuid === item.uuid ? 'btn-select' : 'btn-normal'
                "
                v-for="item in paramsTypeList"
                @click="onClickType(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div v-if="dataList.length > 0" v-loading="dataLoading">
            <div class="wow animate__animated animate__fadeIn live-list-list">
              <el-row :gutter="45">
                <div
                  v-for="(item, index) in dataList"
                  :key="index"
                  @click="onClickDetail(item)"
                >
                  <el-col class="live-list-item-box" :span="6">
                    <div
                      class="live-list-img"
                      :style="{ backgroundImage: `url(${item.pic})` }"
                    >
                      <div class="live-list-img-mask"></div>
                      <div class="live-list-img-play">
                        <i class="el-icon-video-play"></i>
                      </div>
                    </div>
                    <div class="over-num-lines live-list-bottom-title">
                      {{ item.title }}
                    </div>
                    <div
                      class="over-num-lines over-2-lines live-list-bottom-des"
                    >
                      {{ item.summary }}
                    </div>
                    <div class="over-num-lines live-list-bottom-date">
                      {{ item.createDate }}
                    </div>
                  </el-col>
                </div>
              </el-row>
            </div>
          </div>
          <div v-else style="text-align:center;padding:20px 0;">
            <img
              src="../../assets/nosearchMesg.jpg"
              alt=""
              style="width:200px"
            />
          </div>
        </div>
        <div
          style="text-align: center;padding: 10px 0;"
          v-if="dataList.length > 0"
        >
          <el-pagination
            @current-change="onChangeCurrent"
            :current-page="params.current"
            :page-size="params.pageSize"
            background
            layout="prev, pager, next"
            :total="params.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGovHomeVideoList, getGovVideoType } from "../../utils/interface"

export default {
  //   政务视频列表页
  name: "saasList",
  metaInfo: {
    title: "政务视频-宁夏工业企业数字化转型公共服务平台", // set a title
    meta: [
      {
        // set meta
        name: "keywords",
        content:
          "saas平台 | 信息化软件 |人力资源软件 | SRM |crm |MES系统 | 生产管理软件 | 党建管理软件",
      },
      {
        // set meta
        name: "description",
        content:
          "宁夏工业企业数字化转型公共服务平台政务视频提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。",
      },
    ],
  },
  components: {},
  data() {
    return {
      params: {
        programUuid: "",
        status: "1",
        current: 1,
        pageSize: 15,
        total: 0,
      },
      dataList: [],
      dataLoading: false,
      paramsTypeList: [],
    }
  },
  created() {
    this.getDataList()
    this.getTypeList()
  },
  methods: {
    getDataList() {
      this.dataLoading = true
      getGovHomeVideoList(this.params)
        .then((res) => {
          this.dataLoading = false
          this.params.total = res.total
          if (res.list) {
            this.dataList = res.list
          } else {
            this.dataList = []
          }
        })
        .catch((err) => {
          this.dataLoading = false
        })
    },
    getTypeList() {
      getGovVideoType().then((res) => {
        if (res) {
          this.paramsTypeList = [{ name: "全部", uuid: "" }, ...res]
        }
      })
    },
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        path: "/govPlayDetail",
        query: {
          uuid: item.uuid,
          type: "video",
          titleName: "视频列表",
          titleForm: "govVideoList",
        },
      })
      window.open(routeData.href, "_blank")
    },
    onClickType(item) {
      this.params.programUuid = item.uuid
      this.getDataList()
    },
    onChangeCurrent(e) {
      this.params.current = e
      this.getDataList()
    },
  },
}
</script>

<style scoped lang="less">
@basic-colors: #009999;

.gov-video-list {
  background: #ffffff;

  //超出指定行换行
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-1-lines {
    -webkit-line-clamp: 1;
  }

  .over-2-lines {
    -webkit-line-clamp: 2;
  }

  .over-3-lines {
    -webkit-line-clamp: 3;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .gov-video {
    margin-top: 20px;

    .top-title {
      display: flex;
      justify-content: space-between;
    }

    .top-btn {
      display: flex;
    }

    .btn-com {
      width: 70px;
      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      margin-left: 12px;
      font-size: 14px;
      transition: all 0.2s;
    }

    .btn-normal {
      border: 1px solid #777777;
      color: #777777;
      width: 69px;
      height: 29px;
    }

    .btn-select {
      color: white;
      background-color: @basic-colors;
    }

    .live-title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
    }

    .live-list-list {
      margin-top: 35px;
    }

    .live-list-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 290px;
      height: 170px;
      margin-bottom: 8px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      //box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
    }

    .live-list-item-box:hover {
      .live-list-img {
        transform: scale(1.02);
      }

      .live-list-bottom-title {
        color: @basic-colors;
      }
    }

    .live-list-img-mask {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    .live-list-img-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #cccccc;
      //background-color: #526396;
      border-radius: 50%;
      width: 45px;
      height: 45px;
      font-size: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .live-list-tag {
      width: 90px;
      height: 90px;
      position: absolute;
      top: -45px;
      right: -45px;
      transform: rotate(45deg);
    }

    .live-list-tag span {
      position: absolute;
      bottom: 0;
      padding: 2px 0 3px 0;
      display: block;
      font-size: 12px;
      color: #fff;
      background: #ff3526;
      width: 90px;
      text-align: center;
    }

    .live-list-bottom-title {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 7px;
    }

    .live-list-bottom-des {
      font-size: 14px;
      color: #9f9f9f;
      margin-bottom: 7px;
      height: 38px;
    }

    .live-list-bottom-date {
      font-size: 14px;
      color: #333333;
      margin-bottom: 23px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/govInfo/videoList.vue